var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "bank_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11.992v4H7v-4h2zm-4-2h6v8H5v-8zm12 2v4h-2v-4h2zm-4-2h6v8h-6v-8z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 17.992H6a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2zm-12-2a3 3 0 0 0 0 6h12a3 3 0 1 0 0-6H6zm-.071-6H18.07a.929.929 0 0 0 .31-1.804L12.333 6.05a1 1 0 0 0-.666 0L5.619 8.188a.929.929 0 0 0 .31 1.804zm-.976-3.69a2.929 2.929 0 0 0 .976 5.69H18.07a2.929 2.929 0 0 0 .976-5.69l-6.048-2.137a3 3 0 0 0-1.998 0L4.953 6.302z",
    fill: "currentColor"
  })));
};

export { SvgBank as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkgMTEuOTkydjRIN3YtNGgyem0tNC0yaDZ2OEg1di04em0xMiAydjRoLTJ2LTRoMnptLTQtMmg2djhoLTZ2LTh6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE4IDE3Ljk5Mkg2YTEgMSAwIDEwMCAyaDEyYTEgMSAwIDEwMC0yem0tMTItMmEzIDMgMCAwMDAgNmgxMmEzIDMgMCAxMDAtNkg2em0tLjA3MS02SDE4LjA3YS45MjkuOTI5IDAgMDAuMzEtMS44MDRMMTIuMzMzIDYuMDVhMSAxIDAgMDAtLjY2NiAwTDUuNjE5IDguMTg4YS45MjkuOTI5IDAgMDAuMzEgMS44MDR6bS0uOTc2LTMuNjlhMi45MjkgMi45MjkgMCAwMC45NzYgNS42OUgxOC4wN2EyLjkyOSAyLjkyOSAwIDAwLjk3Ni01LjY5bC02LjA0OC0yLjEzN2EzIDMgMCAwMC0xLjk5OCAwTDQuOTUzIDYuMzAyeiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";